import { memo, useMemo, useCallback, useEffect, useState, createRef } from 'react';
import { View, StyleSheet } from 'react-native';
import { I18n, Utils, Container, FormFooter, Navigation, Select } from '../../components';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../../actions/statusTypes';
import { resetStatus } from '../../employer/actions';

import { ONE_DAY, ONE_WEEK, ONE_MONTH, THREE_MONTHS } from '../../../constants/patientReminders';

function _optionReducer(result, current) {
  result.push({
    label: current,
    id: current,
  });
  return result;
}
const reminders = [ONE_DAY, ONE_WEEK, ONE_MONTH, THREE_MONTHS];
const remindersOptions = reminders.reduce(_optionReducer, []);

export default memo(
  connect(
    function (state, ownProps) {
      return {
        saveOccHealthStatus: state.screens.employer.saveOccHealthStatus,
        errorMessage: state.screens.employer.errorMessage,
        occHealthRequirements: state.screens.employer.occHealthRequirementsData,
      };
    },
    function (dispatch) {
      return {
        actions: bindActionCreators({ resetStatus }, dispatch),
      };
    }
  )(function (props) {
    const r = props.requirement;
    const defaultReminder = {
      label: r.patient_reminder || ONE_MONTH,
      id: r.patient_reminder || ONE_MONTH,
    };
    const [selectedRequirement, setRequirement] = useState(defaultReminder);
    useEffect(
      function () {
        if (props.saveOccHealthStatus === SUCCESS) Navigation.dismissAllModals();
      },
      [props.saveOccHealthStatus]
    );
    useEffect(function () {
      return function () {
        props.actions.resetStatus();
      };
    }, []);

    function handleCancel() {
      Navigation.dismissAllModals();
    }

    function handleSave() {
      props.onSave({ ...props.requirement, patient_reminder: selectedRequirement.id });
    }

    function handlePatientReminderSelection(value) {
      setRequirement(value);
    }

    const footer = (
      <FormFooter
        onCancel={handleCancel}
        onSave={handleSave}
        cancelLabel="Cancel"
        saveLabel="Save"
      />
    );

    return (
      <Container
        scrollView={false}
        style={THEME.container}
        stickyFooter={footer}
        renderActivityOverlay={props.saveOccHealthStatus === REQUESTING}
        errorMessage={props.errorMessage?.message}
      >
        <View style={styles.content}>
          <Select
            closeOnSelect={true}
            options={remindersOptions}
            containerStyle={{ width: 200 }}
            value={selectedRequirement}
            onValue={handlePatientReminderSelection}
            webMode={true}
            editable={true}
          />
        </View>
      </Container>
    );
  })
);

const styles = StyleSheet.create({
  content: {
    ...THEME.container,
    alignItems: 'center',
    paddingTop: 100,
  },
});
